module.exports = __webpack_public_path__ + "img/pad-thai.fdf08b01.png";